<template>
  <section class="config-window config-window__wrapper">
    <div class="config-window config-window__title">
      <!-- <h1>{{store.state.pageTitle}}</h1> -->
      <h1>Bygg ditt kök</h1>
      <img v-bind:src="API_URL + '/wp-content/plugins/ytopi-configurator/img/arrow-down-solid.svg'">
    </div>
    <PreviewWindow class="preview-window--mobile" />
    <section v-if="store.state.optionsLoaded" class="selection-container" :class="[(store.state.itemsHaveLoaded == false ) ? 'selection-container--loading' : '']">
    <div v-for="step in store.state.steps" :key="step.order" class="selection">
        <Selection  v-if="step.active"
                    v-bind:order="step.order"
                    v-bind:title="step.title"
                    v-bind:description="step.description"
                    v-bind:endpoint="step.endpoint" 
                    v-bind:productEndpoint="step.productEndpoint" 
                    v-bind:componentType="step.componentType"
                    v-bind:imageLayout="step.imageLayout"
                    v-bind:productImageLayout="step.productImageLayout"
                    v-bind:extraText="step.extraText"/>
    </div>
    </section>
    <div v-if="!store.state.itemsHaveLoaded" class="loading loading__wrapper">
    </div>
  </section>
</template>

<script>

import { inject } from 'vue';
import Selection from './Selection.vue';
import PreviewWindow from './PreviewWindow.vue';
import Linje from './Linje.vue';
import { API_URL } from '../config.js';

export default {
  name: 'ConfigWindow',
  setup() {
    const store = inject('store');
    
    return {
      store,
      'API_URL': API_URL,
    }
  },
  components: {
    Selection,
    PreviewWindow,
    Linje
  }
}
</script>
